<div class="modal fade" id="modalEditVariety" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content variety-edit-modal">
      <div class="modal-header bg-primary text-white">
        <h5 class="modal-title"><i class="bi bi-pencil-square me-2"></i>Editar Variedad</h5>
        <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
      </div>
      <form class="variety-edit-form" [formGroup]="form" (ngSubmit)="saveChanges()">
        <div class="modal-body">
          <div class="edit-summary mb-4">
            <div class="edit-summary__icon"><i class="bi bi-pencil-square"></i></div>
            <div>
              <div class="fw-bold">Editando variedad</div>
              <div class="text-muted">{{ variety?.name || 'Variedad seleccionada' }}</div>
            </div>
          </div>
          <h5 class="text-primary border-bottom pb-2 mb-3">Clasificación</h5>
          <div class="row g-3 mb-4">
            <div class="col-12">
              <label class="form-label">Producto</label>
              <ng-select class="variety-select" formControlName="productId" [items]="products()" bindLabel="nombre"
                bindValue="codigo" placeholder="Seleccione un producto" [searchable]="true"
                [clearable]="true" appendTo="body" (change)="onProductChange($event)"
                (clear)="clearProduct()" />
            </div>
            <div class="col-12">
              <label>Sección</label>
              <input class="form-control form-control-lg" [value]="sectionName()"
                [title]="sectionName()" disabled>
            </div>
            <div class="col-12">
              <label>División</label>
              <input class="form-control form-control-lg" [value]="divisionName()"
                [title]="divisionName()" disabled>
            </div>
            <div class="col-12">
              <label>Clase</label>
              <input class="form-control form-control-lg" [value]="className()"
                [title]="className()" disabled>
            </div>
          </div>

          <h5 class="text-primary border-bottom pb-2 mb-3">Identificación</h5>
          <div class="row g-3 mb-4">
            <div class="col-12"><label>Código INE</label><input class="form-control form-control-lg" formControlName="ineCode"></div>
            <div class="col-12"><label>Nombre</label><input class="form-control form-control-lg" formControlName="name"></div>
            <div class="col-12">
              <label>Unidad de medida</label>
              <ng-select class="variety-select" formControlName="measurementUnitId" [items]="measurementUnits()"
                bindLabel="descripcion" bindValue="pk" placeholder="Seleccione una unidad"
                [searchable]="true" [clearable]="true" appendTo="body"
                (clear)="form.controls.measurementUnitId.setValue(null)" />
            </div>
            <div class="col-12">
              <label>Cantidad base</label>
              <input type="number" min="0.0000001" step="0.0000001"
                class="form-control form-control-lg" formControlName="baseQuantity">
            </div>
          </div>

          <h5 class="text-primary border-bottom pb-2 mb-3">Códigos de Clasificación</h5>
          <div class="row g-3 mb-4">
            <div class="col-12"><label>Código CIIU</label><input class="form-control form-control-lg" formControlName="ciiuCode"></div>
            <div class="col-12"><label>Código NAEG</label><input class="form-control form-control-lg" formControlName="naegCode"></div>
            <div class="col-12"><label>Código NPG</label><input class="form-control form-control-lg" formControlName="npgCode"></div>
            <div class="col-12"><label>Código CCP</label><input class="form-control form-control-lg" formControlName="ccpCode"></div>
          </div>

          <h5 class="text-primary border-bottom pb-2 mb-3">Información Complementaria</h5>
          <div class="row g-3 mb-4">
            <div class="col-12"><label>Referencia</label><input class="form-control form-control-lg" formControlName="reference"></div>
            <div class="col-12">
              <label>Estado</label>
              <ng-select class="variety-select" formControlName="status" [items]="statuses" bindLabel="label"
                bindValue="value" [searchable]="false" [clearable]="true" appendTo="body"
                (clear)="form.controls.status.setValue(null)" />
            </div>
          </div>
          @if (message()) {
            <div class="alert" [class.alert-success]="!error()" [class.alert-danger]="error()">{{ message() }}</div>
          }
        </div>
        <div class="modal-footer variety-edit-actions">
          <button class="btn btn-outline-danger" type="button" (click)="openDeleteModal()"
            [disabled]="submitting()">
            <i class="bi bi-trash"></i> Eliminar
          </button>
          <div class="d-flex gap-2">
            <button class="btn btn-outline-secondary" type="button" data-bs-dismiss="modal"
              [disabled]="submitting()">
              <i class="bi bi-x-lg"></i> Cancelar
            </button>
            <button class="btn btn-info text-white" type="submit" [disabled]="submitting()">
              @if (submitting()) {
                <span class="spinner-border spinner-border-sm me-1"></span> Guardando...
              } @else {
                <i class="bi bi-save me-1"></i> Guardar cambios
              }
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="modal fade" id="modalDeleteVariety" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-sm modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header bg-danger text-white">
        <h5 class="modal-title">Confirmar Eliminación</h5>
        <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body text-center">
        <p class="fw-semibold">¿Desea eliminar esta variedad?</p>
        <p class="text-muted">{{ variety?.name }}</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Cancelar</button>
        <button type="button" class="btn btn-danger" (click)="confirmDelete()"
          [disabled]="submitting()">Eliminar</button>
      </div>
    </div>
  </div>
</div>
